import { render, staticRenderFns } from "./PreguntasFrecuentesComponent.vue?vue&type=template&id=5530addc&scoped=true"
import script from "./PreguntasFrecuentesComponent.vue?vue&type=script&lang=ts"
export * from "./PreguntasFrecuentesComponent.vue?vue&type=script&lang=ts"
import style0 from "./PreguntasFrecuentesComponent.vue?vue&type=style&index=0&id=5530addc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530addc",
  null
  
)

export default component.exports